import { render, staticRenderFns } from "./DataAccess.vue?vue&type=template&id=dcaf8312&scoped=true"
import script from "./DataAccess.vue?vue&type=script&lang=js"
export * from "./DataAccess.vue?vue&type=script&lang=js"
import style0 from "./DataAccess.vue?vue&type=style&index=0&id=dcaf8312&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcaf8312",
  null
  
)

export default component.exports